import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import provedor from './http/provedor'
import http from './http'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.css'
import AxiosPlugin from 'vue-axios-cors';

Vue.config.productionTip = false

Vue.prototype.$http = http

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(AxiosPlugin)

new Vue({
  mode: 'history',
  router,
  store: provedor,  
  render: h => h(App)
}).$mount('#app')